import styled from 'styled-components'
import React from 'react'
import Button from './Button'
import theme from './theme'

const ActionContainer = styled.div`
    display: flex;
    flex-direction: ${props => props.direction};
    align-items: center;
    margin-bottom: 20px;
    .cancel-button {
      ${ props => props.direction === 'column' ? 'margin-top : 10px;' :
        props.direction === 'row-reverse' ? 'margin-right : 40px; ' : 'margin-left : 40px;' }
    }
`

const Actions = ({  submitTxt = 'Valider', onSubmit, submitHref, submitLink, disableSubmit, submitButtonClass = '',
                    cancelTxt = 'Annuler', onCancel, cancelLink, disableCancel, cancelButtonClass = 'clear',
                    direction = 'column',
                    ...props }) => {
  return (<ActionContainer className="actions" direction={direction} { ...props }>
    <Button onClick={ onSubmit } href={ submitHref } to={ submitLink } disabled={ disableSubmit } className={submitButtonClass}>{ submitTxt }</Button>
    { (onCancel || cancelLink) && <Button onClick={ onCancel } color={direction==='column'?null:theme.palette.blue} to={ cancelLink } disabled={ disableCancel } className={'cancel-button ' + cancelButtonClass}>{ cancelTxt }</Button> }
  </ActionContainer>)
}

export default Actions
